import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class SubItem2 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item2">
                <Row style={{backgroundColor: "f4f4f4", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Oportunidades de trabajo</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El profesional egresado de nuestra institución tiene capacidades que le permiten ingresar a un amplio mercado laboral en áreas específicas como la Gerencia, Diseño, Confección y Supervisión de su empresa de confección o de marcas comerciales; como Ilustrador, Patronista y Modelista de indumentaria comercial y a la medida; como Broker de marcas, encargado de línea o división y como comprador en empresas de moda o retail; como Consultor o Asesor de imagen personal y/o empresarial. En el área de marketing, como desarrollador de marcas, visual merchandising, analista de tendencias o coolhunter. En el área de la comunicación, como productor de eventos, estilista, agente y representante para editoriales y fotografía de moda así como, creador y director de blogs en la web. En el área de las Artes y Espectáculos, como diseñador o vestuarista para el teatro, cine y televisión. 
                        </div>
                    </Col>
                    <Col md={4}>
                    
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem2;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoModa/SubItem2.jsx